import React from 'react';
import classnames from 'classnames';
import TextInput from '@mui/material/TextField';

import classes from './TextField.module.scss';

const TextField = props => <TextInput {...props} className={classnames(classes.textField, props.className)} />;

export default TextField;
